const reportWebVitals = (onPerfEntry?: any) => {
  // Reporte de métricas desactivado temporalmente para evitar errores de tipos
};

export default reportWebVitals;
